module.exports = __webpack_public_path__ + "static/media/french-flag.37c62bfe.svg";